import { useEffect, useRef, useState } from "react";

//ASSETS
import LeftArrow from "assets/icons/ArrowLeftHovered.svg";
import RedLoop from "assets/svg/SearchIconRed.svg";
import CoverPlaceholder from "assets/img/CoverPlaceholder.png";
import { ReactComponent as NoDataDark } from "assets/svg/NoDataDark.svg";

// STYLES
import {
  BackToGuidesButton,
  BackToGuidesImage,
  BackToGuidesWrapper,
  CardContainer,
  FlexContainer,
  IframeContainer,
  ImgStyled,
  InputContainer,
  NoDataContainer,
  OfficialAnnouncementsContainer,
  SvgContainer,
  TitleWrapper,
  Wrapper,
} from "./OfficialAnnouncementsStyled";

// LIBRARIES
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

// MISC
import { ButtonType } from "components/Atoms/ButtonAtom/ButtonAtomModel";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { OptionType } from "components/Atoms/InputAtom/InputAtomModel";
import { appRoutes } from "config/AppRoutesConfig";
import { COLORS } from "constants/variables";
import { uploadBaseUrl } from "services/base";

// COMPONENTS
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";
import CustomText from "components/Atoms/CustomText/CustomText";
import InputAtom from "components/Atoms/InputAtom/InputAtom";
import Pagination from "components/Atoms/Paginations/Pagination";
import NewsCard from "components/NewsCard/NewsCard";

// REDUX
import { useSelector } from "react-redux";
import newsAndMediaService from "services/newsAndMediaService";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// CONFIGURATION

const OfficialAnnouncements = () => {
  // PROPERTIES

  // API REQUESTS

  // The tabs for the menu

  // Function to handle tab selection

  // LIBRARY CONSTANTS
  const { t } = useTranslation();
  const navigate = useNavigate();
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);

  // STATE CONSTANTS
  const topRef = useRef(null);
  const [inputText, setInputText] = useState<string>("");
  const [options, setOptions] = useState<OptionType[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  //eslint-disable-next-line
  const [totalPages, setTotalPages] = useState<number>(0);
  const [articles, setArticles] = useState<any>();
  const pageSize = 6;

  // LIFE CYCLE
  useEffect(() => {
    newsAndMediaService
      .getNewsArticlesByCategory(currentPage, pageSize, inputText, 1)
      .then((data) => {
        // console.log("getNewsArticles response", data);
        setArticles(data);
        setTotalPages(data?.meta?.pagination?.pageCount);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [currentPage, pageSize, inputText]);

  // EVENT HANDLERS

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    topRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <OfficialAnnouncementsContainer ref={topRef}>
      <BackToGuidesWrapper
        onClick={() => navigate(appRoutes.news)}
        biggerCursor={biggerCursor}
      >
        <BackToGuidesImage src={LeftArrow} alt="backIcon" />
        <BackToGuidesButton biggerCursor={biggerCursor}>
          <CustomText
            text={t("view.newsAndMedia.officialAnnouncements.backButton")}
            type={TextType.H5boldspaced}
            color={COLORS.RaisinBlack}
          />
        </BackToGuidesButton>
      </BackToGuidesWrapper>
      <TitleWrapper>
        <CustomText
          text={t("view.newsAndMedia.communications")}
          type={TextType.H2}
        />
      </TitleWrapper>
      <InputContainer>
        <form
          onSubmit={(event) => {
            event.preventDefault();

            // if (inputText !== "") {
            //   setOptions([{ option: "0 rezultate", id: 0, path: `/` }]);
            // }
          }}
        >
          <InputAtom
            startAdornment={<ImgStyled src={RedLoop} alt="RedLoopIcon" />}
            endAdornment={
              <ButtonAtom
                text={t("view.newsAndMedia.officialAnnouncements.search")}
                type={ButtonType.ArrowDownDefault}
              />
            }
            placeholder={t(
              "view.newsAndMedia.officialAnnouncements.searchPlaceholder"
            )}
            isSearchBar={true}
            options={options}
            onChange={(e) => setInputText(e.target.value)}
            isModal={true}
          />
        </form>
      </InputContainer>
      {articles?.data?.length > 0 ? (
        <>
          <Wrapper>
            <CardContainer>
              {articles?.data.map((card, index) => {
                return (
                  <NewsCard
                    key={index}
                    id={card?.id}
                    img={
                      card?.attributes?.cover?.data?.attributes?.url?.trim()
                        ? `${uploadBaseUrl}${card?.attributes?.cover?.data?.attributes?.url}`
                        : CoverPlaceholder
                    }
                    title={card?.attributes?.title}
                    timeToRead={card?.attributes?.reading_time || ""}
                    timeline={card?.attributes?.article_date}
                    route={appRoutes.officialsDetails}
                  />
                );
              })}
            </CardContainer>
          </Wrapper>
          {totalPages > 1 && (
            <Pagination
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          )}
          <FlexContainer>
            <IframeContainer>
              <iframe
                src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fm.facebook.com%2Fdepartamenturgente%2F%3Flocale%3Dro_RO&tabs=timeline&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId&width=500&height=600"
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
              ></iframe>
            </IframeContainer>
          </FlexContainer>
        </>
      ) : (
        <NoDataContainer>
          <SvgContainer>
            <NoDataDark />
          </SvgContainer>
          <CustomText
            text={t("app.noData")}
            type={TextType.P1}
            color={COLORS.MetalicSilver}
          />
        </NoDataContainer>
      )}
    </OfficialAnnouncementsContainer>
  );
};

export default OfficialAnnouncements;
